import { CngTileEffect, TileId } from '@contact/upgrade';

export abstract class CngEngagementEffect extends CngTileEffect {
  constructor() {
    super(TileId.ENGAGEMENT);
  }
}
